import { Col, Container, Nav, Navbar, Offcanvas, Row } from "react-bootstrap"
import { Nav_Item } from "../layout/interfaces"
import { useUserContext } from "../user/UserContext"
import './SideMenu.css'

interface SectionProps {
  title: string
  items: Nav_Item[] | null
}

interface SideMenuProps {
  navList: Nav_Item[]
}

const Section: React.FC<SectionProps> = ({ title, items }) => {
  return (
    <section className="menu-section">
      <h5 className="section-title">{title}</h5>
      {items && items.length > 0 ? (
        items.map((item, idx) => (
          <Nav.Link
            key={idx}
            title={item.description}
            className="nav-item"
            href={item.link}
          >
            {item.displayName}
          </Nav.Link>
        ))
      ) : (
        <em className="access-message">Request access from an admin...</em>
      )}
    </section>
  )
}

const SideMenu: React.FC<SideMenuProps> = ({ navList }) => {
  const { userData } = useUserContext()
  const roles = userData?.roles || []

  // Filter nav items by roles and category
  const filteredNav = navList.filter(item => 
    item.userLevel.length === 0 || roles.some(role => item.userLevel.includes(role))
  )

  const getCategoryItems = (cat: string) => filteredNav.filter(item => item.cat === cat)

  return (
    <Navbar key="offcanvas" expand={false} className="side-menu-navbar" collapseOnSelect>
      <Navbar.Toggle aria-controls="offcanvas-navbar" className="navbar-style" />

      <Navbar.Offcanvas
        id="offcanvas-navbar"
        aria-labelledby="offcanvas-navbar-label"
        placement="start"
        className="side-menu-offcanvas"
        backdrop={false} // optional: disable backdrop if you want always visible sidebar
        scroll={true} // allow scrolling inside offcanvas
      >
        <Offcanvas.Header closeButton className="offcanvas-header">
          <Offcanvas.Title id="offcanvas-navbar-label" className="nav-header">
            CRYSTAL BALL
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="offcanvas-body">
          <Container fluid>
            <Nav className="flex-column">
              <Nav.Link href="/" className="nav-home-link">
                HOME
              </Nav.Link>

              <Row>
                <Col className="nav-col">
                  <Section title="Software Development" items={getCategoryItems('dev')} />
                  <Section title="Marketing" items={getCategoryItems('marketing')} />
                  <Section title="Purchasing & Logistics" items={getCategoryItems('purchasing')} />
                  <Section title="External" items={getCategoryItems('external')} />
                </Col>

                <Col className="nav-col">
                  <Section title="Export Tools" items={getCategoryItems('export tools')} />
                  <Section title="Import Tools" items={getCategoryItems('import tools')} />
                  <Section title="Products" items={getCategoryItems('products')} />
                  <Section title="Monitoring" items={getCategoryItems('monitoring')} />
                </Col>
                <Col className="nav-col">
                  <Section title="Fulfillment" items={getCategoryItems('fulfillment')} />
                </Col>
              </Row>

              <Section
                title={userData?.friendlyUserName || 'User'}
                items={[
                  {
                    cat: 'logout',
                    description: 'Logout of your account.',
                    displayName: 'Logout',
                    link: '/logout',
                    userLevel: []
                  }
                ]}
              />
            </Nav>
          </Container>
        </Offcanvas.Body>
      </Navbar.Offcanvas>
    </Navbar>
  )
}

export default SideMenu
